import api from './client';

export const importLookup = (type, sourceProject, targetProject) =>
  api.post('/import-lookups', { type, sourceProject, targetProject });
